<script>
  import { Icon, Item } from "t2c-components";
  import { _ as t } from "svelte-i18n";

  export let lawcase;
</script>

<Item
  link={`/lawcase/${lawcase.id}/`}
  text={lawcase.title}
  description={lawcase.description ? lawcase.description : null}
>
  <div slot="icon" style="padding-right: 12px">
    <Icon inline={true} icon="lawcase" fill="#1f363d" stroke="none" />
  </div>
  <div slot="stats" class="stats">
    <div class:empty={lawcase.countFolders == 0}>
      {$t("lawcases.numFolders", { values: { n: lawcase.countFolders } })}
    </div>
    <div class:empty={lawcase.countDocuments == 0}>
      {$t("lawcases.numDocuments", { values: { n: lawcase.countDocuments } })}
    </div>
  </div>
</Item>
